import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { PagedResponse } from "@models/response.model";
import { AppUtils } from "@app/shared/util/app.utils";

import { ValueStreamConfiguration } from '@app/shared/models/value-stream-configuration.model';
import * as _ from 'lodash';

@Injectable()
export class ValueStreamService {
    static readonly API_BASE_PATH = `${environment.baseURL}/api/value-stream-configurations`;

    constructor(private http: HttpClient) {}

    getAll(tableConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(tableConfig);
        return this.http.get<PagedResponse<ValueStreamConfiguration>>(
            `${ValueStreamService.API_BASE_PATH}`,
            { params }
        );
    }

    get(id: number) {
        return this.http.get<ValueStreamConfiguration>(
            `${ValueStreamService.API_BASE_PATH}/${id}`
        );
    }

    getAvailableValueStreams() {
        return this.http.get<string[]>(
            `${ValueStreamService.API_BASE_PATH}/available`
        );
    }

    create(vs: ValueStreamConfiguration) {
        return this.http.post<ValueStreamConfiguration>(
            `${ValueStreamService.API_BASE_PATH}`,
            this.getSavePayload(vs)
        );
    }

    update(vs: ValueStreamConfiguration) {
        const payload = this.getSavePayload(vs);
        return this.http.put<ValueStreamConfiguration>(
            `${ValueStreamService.API_BASE_PATH}/${payload.id}`,
            payload
        );
    }

    delete(vs: ValueStreamConfiguration) {
        return this.http.delete<number>(
            `${ValueStreamService.API_BASE_PATH}/${vs.id}`
        );
    }

    private getSavePayload(vs: ValueStreamConfiguration): any {
        return {
            id: vs.id,
            valueStreamName: vs.valueStreamName,
            emailAddress: vs.emailAddress,
            lineIds: _.map(vs.lines, 'id')
        };
    }
}
